"use client";

import ErrorPage from "@/components/sections/errors/ErrorPage";

export default function NotFound() {
	return <ErrorPage type="404" />;
}
